<script setup lang="ts">
import { computed, ref, watch } from 'vue'
import { NButton, NFormItem, NInput, NModal } from 'naive-ui'

const props = defineProps<{ show: boolean; mode: 'create' | 'rename'; initialName: string }>()
const emit = defineEmits<{ 'update:show': [value: boolean]; submit: [name: string] }>()

const CHANNEL_NAME_RE = /^[a-z0-9][a-z0-9_-]{0,63}$/

const name = ref('')
const touched = ref(false)

watch(
  () => props.show,
  (open) => {
    if (!open) return
    name.value = props.mode === 'rename' ? props.initialName : ''
    touched.value = false
  },
)

const normalized = computed(() => name.value.trim().toLowerCase())
const valid = computed(() => CHANNEL_NAME_RE.test(normalized.value))
const error = computed(() =>
  touched.value && !valid.value
    ? 'Lowercase letters, digits, - and _ only (max 64), starting with a letter or digit.'
    : '',
)

function submit(): void {
  touched.value = true
  if (valid.value) emit('submit', normalized.value)
}
</script>

<template>
  <NModal
    :show="show"
    preset="card"
    :title="mode === 'create' ? 'New channel' : 'Rename channel'"
    class="max-w-md"
    @update:show="emit('update:show', $event)"
  >
    <form class="flex flex-col gap-3" @submit.prevent="submit">
      <NFormItem :show-label="false" :validation-status="error ? 'error' : undefined" :feedback="error">
        <NInput v-model:value="name" placeholder="release-coordination" autofocus data-testid="create-name" />
      </NFormItem>
      <div class="flex justify-end gap-2">
        <NButton @click="emit('update:show', false)">Cancel</NButton>
        <NButton type="primary" attr-type="submit" data-testid="form-submit">
          {{ mode === 'create' ? 'Create' : 'Rename' }}
        </NButton>
      </div>
    </form>
  </NModal>
</template>
